module.exports = __webpack_public_path__ + "img/流体力学2_5.7321596b.jpg";